module.exports = __webpack_public_path__ + "icofont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/icofont/fonts/icofont.woff2
// module id = 2880
// module chunks = 67